import React, { Component } from 'react';
import golbeldata from '../data.json';
import Appnav from './Appnav.js'
import AppFooter from './Footer.js'
import AppTopHeader from './AppTopHeader.js'
import { Link, Route, Switch } from 'react-router-dom';

class Rooms extends Component {
  constructor(props) {
    super(props);

    this.concerts = golbeldata;
  }

  componentDidMount() {
    document.title = this.concerts.HotelName+" Rooms";
    window.$('#parallax-pagetitle').parallax("50%", -0.55);
  }

  render() {
    return (
      <div>
        <AppTopHeader data={this.concerts} />
        <header>
          <Appnav data={this.concerts} />
        </header>
        <section class="parallax-effect">
          <div id="parallax-pagetitle" style={{ backgroundImage: 'url("images/parallax/' + this.concerts.parllex + '")' }}>
            <div class="color-overlay">

              <div class="container">
                <div class="row">
                  <div class="col-sm-12">
                    <ol class="breadcrumb">
                      <li><a href="index.html">Home</a></li>
                      <li class="active">Rooms</li>
                    </ol>
                    <h1>Rooms</h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class="rooms mt100">
          <div class="container">
            <div class="row room-list">
              {
                this.concerts.Roomhome.map(function (item) {
                  return <div class="col-sm-4 single">
                    <div class="room-thumb"> <img src={'images/rooms/Thumblarge/' + item.Path} alt="room 1" class="img-responsive" />
                      <div class="mask">
                        <div class="main">
                          <h5>{item.heading}</h5>
                          <div class="price">{item.Price}</div>
                        </div>
                        <div class="content">
                          <p><span>{item.Title}</span> {item.Description}</p>
                          <div class="row">
                            <div class="col-xs-6">
                              <ul class="list-unstyled">
                                <li><i class="fa fa-check-circle"></i> Laundry</li>
                                <li><i class="fa fa-check-circle"></i> Bathroom</li>
                              </ul>
                            </div>
                            <div class="col-xs-6">
                              <ul class="list-unstyled">
                                <li><i class="fa fa-check-circle"></i> Free Wi-Fi</li>
                                <li><i class="fa fa-check-circle"></i> Incl. breakfast</li>

                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>;
                })
              }
            </div>
          </div>
        </section>
        <AppFooter data={this.concerts} />
        <div id="go-top"><i class="fa fa-angle-up fa-2x"></i></div>

      </div>
    )
  }
}
export default Rooms;


// WEBPACK FOOTER //
// ./src/components/Rooms.js